textFilterFilter.$inject = ['$rootScope'];
function textFilterFilter($rootScope){
  return function(products, partSearchText, kitSearchFiltered) {
    let output = [];
    if(partSearchText) {
      products.forEach((product) => {
        let productName = product.name;
        if(productName) {
          let productNameLowercase = productName.toLowerCase();
          let partSearchTextLowercase = partSearchText.toLowerCase();
          if(productNameLowercase.indexOf(partSearchTextLowercase) !== -1) {
            if(!kitSearchFiltered) {
              if(product.relatedParentId === kitSearchFiltered) {
                output.push(product);
              }
            }
            else {
              output.push(product);
            }
          }
        }
      });
      return output;
    }
    return products;
  };
}

function capitalize(){
  return function(input, all) {
    return (!!input) ? input.replace(/([^\W_]+[^\s-]*) */g,
      function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();}) : '';
  }
}

function ngEnter(){
  return function (scope, element, attrs) {
    element.bind("keydown keypress", function (event) {
      if (event.which === 13) {
        scope.$apply(function () {
          scope.$eval(attrs.ngEnter);
        });

        event.preventDefault();
      }
    });
  };
}

function b2bModalSelect(){
  return function(data){
    if (data.length > 83) {
      data = data.slice(0, 80);
      data += '...';
    }
    return data;
  };
}


s4bCurrency.$inject = ['$filter'];
function s4bCurrency($filter){
  return function(input, currency, decimals) {
    let decimal = decimals || 2;

    if(currency === undefined) { currency = ''; }
    else if(currency !== '') {
      currency = currency + ' ';
    }
    input = parseFloat(input);
    input = input.toFixed(input % 1 === 0 ? 0 : decimal);
    return currency + ' ' + input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  };
}

function fileSize() {
  let units = [
    'bytes',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB'
  ];
  return function( bytes, precision ) {
    if ( isNaN( parseFloat( bytes )) || ! isFinite( bytes ) ) {
      return '?';
    }
    
    let unit = 0;
    
    while ( bytes >= 1024 ) {
      bytes /= 1024;
      unit ++;
    }
    
    return bytes.toFixed( + precision ) + ' ' + units[ unit ];
  };
}


export default {
  textFilterFilter : textFilterFilter,
  capitalize : capitalize,
  fileSize : fileSize,
  ngEnter : ngEnter,
  s4bCurrency : s4bCurrency,
  b2bModalSelect : b2bModalSelect
};



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/shared/filters/filters.simple.js
 **/